import { nonEmptyStringValidator } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
import { formAssetsValidator } from '../../../../subcomponents/form/form/types/assets';
import { formEventsValidator } from '../../../../subcomponents/form/form/types/events';
import { reactChildrenValidator } from '../../../../validators/react-children';
import { defaultMemberPasswordResetCreateFormConfig, memberPasswordResetCreateFormConfigValidator } from './config';
import { defaultMemberPasswordResetCreateFormDisplayText, memberPasswordResetCreateFormDisplayTextValidator } from './display-text';
/**
 * Default props for the Member Password Reset Create Form component.
 */
export const defaultMemberPasswordResetCreateFormProps = {
    assets: {},
    config: defaultMemberPasswordResetCreateFormConfig,
    displayText: defaultMemberPasswordResetCreateFormDisplayText,
    events: {},
    children: undefined
};
/**
 * Props validator for the Member Password Reset Create Form component.
 */
export const MemberPasswordResetCreateFormPropsValidator = Validator.object({
    formId: Validator.optional(nonEmptyStringValidator),
    displayText: memberPasswordResetCreateFormDisplayTextValidator,
    config: memberPasswordResetCreateFormConfigValidator,
    events: formEventsValidator,
    assets: formAssetsValidator,
    children: reactChildrenValidator
});
//# sourceMappingURL=props.js.map